/**
 电站运行看板-故障
 */

import React, { Component } from "react";
import { Tabs, Table, Button } from "antd";
import PropTypes from "prop-types";
import { triggerDownloadFiles } from "@/utils/utils";
import { initModals } from "@/state/action/comAction";
import ModalMulterCore from "@/components/feedback/scModalMulterCore";
import FaultTypeModal from "./detail/faultType";
import FaultDeviceModal from "./detail/faultDevice";
import MaterialModal from "./detail/material";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
const TabPane = Tabs.TabPane;
@connect((state) => state)
class FaultChart extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubList;
    this.yunwei = this.props.intl.messages.commonBase;

    this.state = {
      faultTypeTitle: this.internationalization.btn1, // '故障类型TOP20排名',
      exporting: false,
      columns1: [
        {
          title: "排名",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "故障名称",
          dataIndex: "faultName",
          key: "faultName",
        },
        {
          title: "故障数量",
          key: "faultNum",
          render: (row) => {
            return (
              <a
                onClick={(e) => {
                  // 直接更新modalConfig中的title属性
                  this.modalConfig[0].title = "故障类型-" + row.faultName;
                  this.context.store.dispatch(
                    initModals("faultTypeModal", {
                      ...this.props.modalParam,
                      faultCode: row.faultCode,
                    }),
                  );
                }}>
                {row.faultNum}
              </a>
            );
          },
        },
        {
          title: "故障率",
          dataIndex: "faultRate",
          key: "faultRate",
        },
      ],
      columns2: [
        {
          title: "排名",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "场站名称",
          dataIndex: "stationName",
          key: "stationName",
        },
        {
          title: "故障设备数量",
          key: "faultStubNum",
          render: (row) => {
            return (
              <a
                onClick={(e) => {
                  this.context.store.dispatch(
                    initModals("faultDeviceModal", {
                      ...this.props.modalParam,
                      stationId: row.stationId,
                    }),
                  );
                }}>
                {row.faultStubNum}
              </a>
            );
          },
        },
        {
          title: "故障工单数",
          dataIndex: "faultTicketNum",
          key: "faultTicketNum",
        },
        {
          title: "故障率",
          dataIndex: "faultRate",
          key: "faultRate",
        },
      ],
      columns3: [
        {
          title: "排名",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "物料名称",
          dataIndex: "materialName",
          key: "materialName",
        },
        {
          title: "投入数量",
          key: "materialNum",
          render: (row) => {
            return (
              <a
                onClick={(e) => {
                  this.context.store.dispatch(
                    initModals("materialModal", {
                      ...this.props.modalParam,
                      materialCode: row.materialCode,
                    }),
                  );
                }}>
                {row.materialNum}
              </a>
            );
          },
        },
        {
          title: "投入占比",
          dataIndex: "chargedQuantity",
          key: "chargedQuantity",
        },
      ],
    };

    // 定义modals
    this.modalConfig = [
      {
        key: "faultTypeModal",
        width: 800, // 自定义模态框宽度
        title: "故障类型", // 模态窗口的标题
        content: FaultTypeModal, // 自定义 jsx内容
      },
      {
        key: "faultDeviceModal",
        width: 800, // 自定义模态框宽度
        title: "故障设备", // 模态窗口的标题
        content: FaultDeviceModal, // 自定义 jsx内容
      },
      {
        key: "materialModal",
        width: 800,
        title: "投入物料", // '物料投入',
        content: MaterialModal,
      },
    ];
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  handleClick = async (api, fileName) => {
    this.setState({
      exporting: true,
    });
    await triggerDownloadFiles(
      api,
      {
        ...this.props.modalParam,
      },
      fileName,
      ".xlsx",
      "get",
    );
    this.setState({
      exporting: false,
    });
  };

  render() {
    const content = (
      <div className="page-panel">
        <div className="display-board">
          <div className="item">
            <div className="inner" style={{ height: "421px" }}>
              <div
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ fontSize: "18px", fontWeight: "600" }} className="line-title">
                  故障类型TOP20排名
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Button
                    loading={this.state.exporting}
                    onClick={() => {
                      this.handleClick("mtsV2/fault/type/report/export", "故障类型Top20排名导出");
                    }}
                    type="primary"
                    style={{ margin: "5px" }}>
                    导出
                  </Button>
                </div>
              </div>
              <div style={{ flex: 1 }}>
                <Table
                  style={{ minHeight: "340px", height: "340px", overflowY: "auto" }}
                  dataSource={this.props.dataSource1}
                  columns={this.state.columns1}
                  pagination={false}
                />
              </div>
            </div>
          </div>
          <div className="item">
            <div className="inner" style={{ height: "421px" }}>
              <div
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ fontSize: "18px", fontWeight: "600" }} className="line-title">
                  故障场站TOP20排名
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Button
                    loading={this.state.exporting}
                    onClick={() => {
                      this.handleClick(
                        "mtsV2/fault/station/report/export",
                        "故障场站Top20排名导出",
                      );
                    }}
                    type="primary"
                    style={{ margin: "5px" }}>
                    导出
                  </Button>
                </div>
              </div>

              <div style={{ flex: 1 }}>
                <Table
                  style={{ minHeight: "340px", height: "340px", overflowY: "auto" }}
                  dataSource={this.props.dataSource2}
                  columns={this.state.columns2}
                  pagination={false}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="display-board">
          <div className="item">
            <div className="inner" style={{ height: "500px" }}>
              <div
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ fontSize: "18px", fontWeight: "600" }} className="line-title">
                  投入物料TOP10排名
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Button
                    loading={this.state.exporting}
                    onClick={() => {
                      this.handleClick(
                        "mtsV2/fault/material/report/export",
                        "投入物料Top10排名导出",
                      );
                    }}
                    type="primary"
                    style={{ margin: "5px" }}>
                    导出
                  </Button>
                </div>
              </div>
              <div style={{ flex: 1 }}>
                <Tabs defaultActiveKey="1" destroyInactiveTabPane={true}>
                  <TabPane tab="全部物料" key="1">
                    <Table
                      style={{ minHeight: "340px", height: "340px", overflowY: "auto" }}
                      dataSource={this.props.dataSource3}
                      columns={this.state.columns3}
                      pagination={false}
                    />
                  </TabPane>
                  <TabPane tab="免费物料" key="2">
                    <Table
                      style={{ minHeight: "340px", height: "340px", overflowY: "auto" }}
                      dataSource={this.props.dataSource4}
                      columns={this.state.columns3}
                      pagination={false}
                    />
                  </TabPane>
                  <TabPane tab="收费物料" key="3">
                    <Table
                      style={{ minHeight: "340px", height: "340px", overflowY: "auto" }}
                      dataSource={this.props.dataSource5}
                      columns={this.state.columns3}
                      pagination={false}
                    />
                  </TabPane>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
    return (
      <div>
        <ModalMulterCore config={this.modalConfig}></ModalMulterCore>
        {content}
      </div>
    );
  }
}

export default injectIntl(FaultChart);



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/faultChart.js